module.exports = __webpack_public_path__ + "static/media/thumb_verdegente.a8e15820.jpg";